import { render, staticRenderFns } from "./AdminQuestionDetail.vue?vue&type=template&id=69221371&scoped=true&"
import script from "./AdminQuestionDetail.vue?vue&type=script&lang=js&"
export * from "./AdminQuestionDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69221371",
  null
  
)

export default component.exports